import React from 'react';
import { OEToggle } from '../../../../../../../global/oe-toggle/oe-toggle';
import { SpeakerBioAccordion } from './speaker-bio-accordion';
import { ISyncSpeakersListItem } from '../sync-speakers.viewmodel';
import { SYNC_SPEAKERS_PROFILE_IMAGE_ALT } from '../sync-speakers-constants';

interface IProps extends ISyncSpeakersListItem {
    enabled: boolean;
    toggleSpeaker: () => void;
    toggleBio?: () => void;
}

const SpeakerListItem: React.FC<IProps> = ({
    firstName,
    lastName,
    title,
    organizationName,
    biography,
    profileImageWithUrl,
    bioExpanded,
    enabled,
    toggleSpeaker,
    toggleBio,
}) => {
    const name = firstName + ' ' + lastName;
    const renderProfileImageIfSrcProvided = () => {
        return profileImageWithUrl?.assetUrl
            ? <img src={profileImageWithUrl?.assetUrl} alt={profileImageWithUrl?.title || SYNC_SPEAKERS_PROFILE_IMAGE_ALT} />
            : null;
    };
    return enabled ? (
        <div className='speaker-list__item'>
            <OEToggle isSelected={enabled} className='list-item-switch' onClick={toggleSpeaker}/>
            <div className='list-item-head'>
                <div className='list-item-head__photo'>
                    {renderProfileImageIfSrcProvided()}
                </div>
                <div className='list-item-head__text-info'>
                    <p className='text-info__item text-info__item--bold'>{name}</p>
                    <p className='text-info__item'>{title}</p>
                    <p className='text-info__item'>{organizationName}</p>
                </div>
            </div>
            <SpeakerBioAccordion content={biography} openByDefault={bioExpanded} onToggleAccordion={toggleBio}/>
        </div>
    ) : (
        <div className='speaker-list__item speaker-list__item--disabled'>
            <OEToggle isSelected={enabled} className='list-item-switch' onClick={toggleSpeaker}/>
            <div className='list-item-head'>
                <div className='list-item-head__text-info'>
                    <p className='text-info__item text-info__item--bold'>{name}</p>
                </div>
            </div>
        </div>
    );
};

export { SpeakerListItem };
